import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'lf-auth-layout',
    styleUrls: ['./auth-layout.scss'],
    templateUrl: './auth-layout.component.html',
    standalone: true,
    imports: [RouterOutlet],
})
export class AuthLayoutComponent
{
}
